(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alandra-homepage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.alandra-home');
    if (!section) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var sel = '.al-featured__media, .al-featured__content, .al-inside__content, .al-inside__media, .al-review';
    var items = section.querySelectorAll(sel);
    if (!items.length) return;

    items.forEach(function (el) { el.classList.add('al-reveal'); });

    section.querySelectorAll('.al-reviews__grid').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) {
        c.style.setProperty('--i', i);
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alandra-product-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.alandra-pdp');
    sections.forEach(function (root) {
      var main = root.querySelector('[data-main-image]');
      var thumbs = root.querySelectorAll('.alandra-thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          if (main) { main.src = t.getAttribute('data-full'); }
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
      var qtyInput = root.querySelector('.alandra-qty__input');
      root.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var val = parseInt(qtyInput.value, 10) || 1;
          if (btn.getAttribute('data-qty') === 'plus') { val += 1; }
          else { val = Math.max(1, val - 1); }
          qtyInput.value = val;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.getElementById('header-component');
    if (!header) return;
    var body = document.body;
    var openCount = 0;
    var current = null;

    var scrim = header.querySelector('[data-scrim]');
    var panels = {};
    header.querySelectorAll('[data-panel]').forEach(function (p) { panels[p.getAttribute('data-panel')] = p; });

    /* PORTAL: Overlays ans <body> hängen */
    var PORTAL_ID = 'alandra-header-portal';
    var oldPortal = document.getElementById(PORTAL_ID);
    if (oldPortal && oldPortal.parentNode) oldPortal.parentNode.removeChild(oldPortal);
    var portal = document.createElement('div');
    portal.id = PORTAL_ID;
    if (scrim) portal.appendChild(scrim);
    Object.keys(panels).forEach(function (k) { portal.appendChild(panels[k]); });
    body.appendChild(portal);

    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    function money(cents) {
      try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format((cents || 0) / 100); }
      catch (e) { return '£' + ((cents || 0) / 100).toFixed(2); }
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function img(url) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
    function lock() { openCount++; body.classList.add('alandra-no-scroll'); }
    function unlock() { openCount = Math.max(0, openCount - 1); if (openCount === 0) body.classList.remove('alandra-no-scroll'); }

    /* ════ RECENTLY VIEWED ════ */
    var RECENT_KEY = 'alandra_recent_v1';
    function getRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
    (function trackProduct() {
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (!p || !p.id) return;
          var list = getRecent().filter(function (x) { return x.id !== p.id; });
          list.unshift({ id: p.id, title: p.title, url: p.url, image: p.featured_image || (p.images && p.images[0]) || '', price: p.price });
          try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
        }).catch(function () {});
    })();

    function resultRow(url, image, title, priceStr) {
      return '<a class="alandra-result" href="' + url + '">' +
        (image ? '<img class="alandra-result__img" src="' + img(image) + '" alt="" loading="lazy">' : '') +
        '<span class="alandra-result__info"><span class="alandra-result__title">' + esc(title) + '</span>' +
        (priceStr ? '<span class="alandra-result__price">' + priceStr + '</span>' : '') + '</span>' +
        '<svg class="alandra-result__arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    }

    function open(name) {
      if (!panels[name]) return;
      if (current && current !== name) closeOnly(current);
      if (current === name) return;
      current = name;
      panels[name].classList.add('is-open');
      panels[name].setAttribute('aria-hidden', 'false');
      scrim.classList.add('is-open');
      lock();
      var burger = header.querySelector('[data-open="menu"]');
      if (name === 'menu' && burger) burger.classList.add('is-open');
      if (name === 'search') { showDefault(); var i = panels.search.querySelector('[data-search-input]'); setTimeout(function(){ i && i.focus(); }, 120); }
      if (name === 'cart') loadCart();
    }
    function closeOnly(name) {
      if (!panels[name]) return;
      panels[name].classList.remove('is-open');
      panels[name].setAttribute('aria-hidden', 'true');
      var burger = header.querySelector('[data-open="menu"]');
      if (name === 'menu' && burger) burger.classList.remove('is-open');
      unlock();
    }
    function close() {
      if (!current) return;
      closeOnly(current);
      scrim.classList.remove('is-open');
      current = null;
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open]');
      if (opener) { e.preventDefault(); open(opener.getAttribute('data-open')); return; }
      if (e.target.closest('[data-close]')) { e.preventDefault(); close(); return; }
    });
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function badge(n) {
      var b = header.querySelector('[data-cart-count]'), link = header.querySelector('[data-cart-link]');
      if (!b) return;
      b.textContent = n;
      if (n > 0) { b.removeAttribute('hidden'); link && link.classList.add('has-items'); }
      else { b.setAttribute('hidden', ''); link && link.classList.remove('has-items'); }
    }

    /* ════ CART ════ */
    var cartPanel = panels.cart;
    function itemHTML(it) {
      return '<div class="acd-item" data-key="' + it.key + '" data-qty="' + it.quantity + '">' +
        '<a class="acd-item__img" href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="acd-item__info"><a class="acd-item__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
          (it.variant_title ? '<span class="acd-item__variant">' + esc(it.variant_title) + '</span>' : '') +
          '<div class="acd-item__ctrl"><span class="acd-qty"><button type="button" data-dec aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Increase">+</button></span>' +
          '<button type="button" class="acd-item__remove" data-remove>Remove</button></div></div>' +
        '<span class="acd-item__price">' + money(it.final_line_price) + '</span></div>';
    }
    function freeShip(total) {
      var box = cartPanel.querySelector('[data-freeship]');
      var thr = parseFloat(header.getAttribute('data-free-threshold')) || 0;
      if (thr <= 0) { box.innerHTML = '<div class="acd-done">FREE UK delivery included</div>'; return; }
      var thrC = thr * 100;
      if (total >= thrC) { box.innerHTML = '<div class="acd-done">You\'ve unlocked FREE UK delivery!</div>'; return; }
      var pct = Math.min(100, Math.round(total / thrC * 100));
      box.innerHTML = '<div class="acd-msg">Spend <strong>' + money(thrC - total) + '</strong> more for FREE UK delivery</div><div class="acd-track"><div class="acd-fill" style="width:' + pct + '%"></div></div>';
    }
    function renderCart(cart) {
      badge(cart.item_count);
      var content = cartPanel.querySelector('[data-cart-content]'), emptyEl = cartPanel.querySelector('[data-cart-empty]'), foot = cartPanel.querySelector('[data-cart-foot]'), ship = cartPanel.querySelector('[data-freeship]');
      if (cart.item_count === 0) { content.hidden = true; foot.hidden = true; ship.style.display = 'none'; emptyEl.hidden = false; return; }
      emptyEl.hidden = true; content.hidden = false; foot.hidden = false; ship.style.display = '';
      cartPanel.querySelector('[data-cart-items]').innerHTML = cart.items.map(itemHTML).join('');
      cartPanel.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
      freeShip(cart.total_price);
    }
    function loadCart() {
      cartPanel.classList.add('is-loading');
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart).catch(function(){}).then(function(){ cartPanel.classList.remove('is-loading'); });
    }
    function changeQty(key, qty) {
      cartPanel.classList.add('is-loading');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); document.dispatchEvent(new CustomEvent('cart:updated')); }).catch(function(){}).then(function(){ cartPanel.classList.remove('is-loading'); });
    }
    cartPanel.addEventListener('click', function (e) {
      var row = e.target.closest('[data-key]'); if (!row) return;
      var key = row.getAttribute('data-key'), q = parseInt(row.getAttribute('data-qty'), 10);
      if (e.target.closest('[data-inc]')) changeQty(key, q + 1);
      else if (e.target.closest('[data-dec]')) changeQty(key, Math.max(0, q - 1));
      else if (e.target.closest('[data-remove]')) changeQty(key, 0);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function () { if (btn) btn.removeAttribute('aria-busy'); open('cart'); }).catch(function () { form.submit(); });
    });

    /* ════ SEARCH ════ */
    var sInput = panels.search.querySelector('[data-search-input]');
    var sRecent = panels.search.querySelector('[data-search-recent]');
    var sPromo = panels.search.querySelector('[data-search-promo]');
    var sResults = panels.search.querySelector('[data-search-results]');
    var t;

    function showDefault() {
      if (sResults) { sResults.hidden = true; sResults.innerHTML = ''; }
      var recent = getRecent();
      if (recent.length && sRecent) {
        sRecent.innerHTML = '<p class="alandra-search__label">Recently viewed</p>' + recent.map(function (p) { return resultRow(p.url, p.image, p.title, money(p.price)); }).join('');
        sRecent.hidden = false;
        if (sPromo) sPromo.hidden = true;
      } else {
        if (sRecent) sRecent.hidden = true;
        if (sPromo) sPromo.hidden = false;
      }
    }

    sInput && sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(t);
      if (q.length < 2) { showDefault(); return; }
      if (sRecent) sRecent.hidden = true;
      if (sPromo) sPromo.hidden = true;
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            sResults.hidden = false;
            if (!ps.length) { sResults.innerHTML = '<p class="alandra-search__empty">No matches for “' + esc(q) + '”.</p><a class="alandra-search__all" href="/search?q=' + encodeURIComponent(q) + '">View all results</a>'; return; }
            sResults.innerHTML = ps.map(function (p) {
              var price = (typeof p.price === 'number' || /^\d+$/.test(p.price)) ? money(parseInt(p.price, 10)) : (p.price || '');
              var im = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
              return resultRow(p.url, im, p.title, price);
            }).join('') + '<a class="alandra-search__all" href="/search?q=' + encodeURIComponent(q) + '">View all results →</a>';
          }).catch(function(){});
      }, 220);
    });

    ['cart:updated','cart:refresh','cart:change','cart:added'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { badge(c.item_count); }).catch(function(){});
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
